import axiosClient from "./axiosClient";

const customPublicationApi = {
  getLatest: () =>
    axiosClient.get("/custom-publications/latest/", { authRequired: false }), // Assuming no auth required based on curl
  getById: (id) =>
    axiosClient.get(`/custom-publications/${id}/`, { authRequired: false }),
};

export default customPublicationApi; 